import { Lock } from 'lucide-react';

import { CardListItem } from '@/components/ui/card-list';
import { PieceIcon } from '@/features/pieces/components/piece-icon';
import {
  HandleSelectCallback,
  StepMetadataWithSuggestions,
} from '@/features/pieces/lib/types';
import { ActionType, TriggerType } from '@activepieces/shared';

import { getCoreActions } from '../../../features/pieces/lib/pieces-hook';

type PieceSearchSuggestionsProps = {
  pieceMetadata: StepMetadataWithSuggestions;
  handleSelectOperationSuggestion: HandleSelectCallback;
  isLocked?: boolean;
};

const stepMetadataSuggestions = (stepMetadata: StepMetadataWithSuggestions) => {
  switch (stepMetadata.type) {
    case TriggerType.PIECE:
      return stepMetadata.suggestedTriggers;
    case ActionType.PIECE:
      return stepMetadata.suggestedActions;
    case ActionType.CODE:
    case ActionType.ROUTER:
    case ActionType.LOOP_ON_ITEMS: {
      return getCoreActions(stepMetadata.type);
    }
  }
};

const PieceSearchSuggestions = ({
  pieceMetadata,
  handleSelectOperationSuggestion,
  isLocked = false,
}: PieceSearchSuggestionsProps) => {
  const suggestions = stepMetadataSuggestions(pieceMetadata);
  return (
    <div className="flex flex-col gap-0">
      {suggestions?.map((suggestion) => (
        <CardListItem
          className="p-3 text-sm gap-2 items-center "
          key={suggestion.displayName}
          onClick={(e) => {
            e.stopPropagation();
            handleSelectOperationSuggestion(pieceMetadata, suggestion);
          }}
        >
          <div className="opacity-0">
            <PieceIcon
              logoUrl={pieceMetadata.logoUrl}
              displayName={pieceMetadata.displayName}
              showTooltip={false}
              size={'sm'}
            ></PieceIcon>
          </div>

          <span title={suggestion.displayName} className="flex-1 truncate">
            {suggestion.displayName}
          </span>
          {isLocked && (
            <Lock className="h-3 w-3 shrink-0 mr-2 text-muted-foreground" />
          )}
        </CardListItem>
      ))}
    </div>
  );
};

export { PieceSearchSuggestions };
